const translation = {
  title: 'การทดสอบการดึงข้อมูล',
  settingTitle: 'การตั้งค่าการดึงข้อมูล',
  desc: 'ทดสอบเอฟเฟกต์การตีของความรู้ตามข้อความแบบสอบถามที่กําหนด',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  recents: 'ล่าสุด',
  table: {
    header: {
      source: 'ที่มา',
      text: 'ข้อความ',
      time: 'เวลา',
    },
  },
  input: {
    title: 'ข้อความต้นฉบับ',
    placeholder: 'กรุณาป้อนข้อความแนะนําให้ใช้ประโยคประกาศสั้น ๆ',
    countWarning: 'สูงสุด 200 อักขระ',
    indexWarning: 'ความรู้คุณภาพสูงเท่านั้น',
    testing: 'การทดสอบ',
  },
  hit: {
    title: 'ย่อหน้าดึงข้อมูล',
    emptyTip: 'ผลการทดสอบการดึงข้อมูลจะแสดงที่นี่',
  },
  noRecentTip: 'ไม่มีผลการค้นหาล่าสุดที่นี่',
  viewChart: 'ดูแผนภูมิเวกเตอร์',
  viewDetail: 'ดูรายละเอียด',
  open: 'เปิด',
  keyword: 'คำ',
  chunkDetail: 'รายละเอียดก้อน',
  records: 'เรก คอร์ด',
  hitChunks: 'กด {{num}} ก้อนลูก',
}

export default translation
